export const CUSTOM_EVENT_WS_SHOW_ON_LOGOUT = "showPopupSaveWSonLogOut";

export const SAVE_WORKSPACE_BEHAVIOURS = {
  ASK: 1,
  SAVE: 2,
  CREATE_NEW: 3,
  DO_NOT_SAVE: 4
};

export const SAVE_WORKSPACE_BEHAVIOURS_LABELS = {
  [SAVE_WORKSPACE_BEHAVIOURS.ASK]: "ask",
  [SAVE_WORKSPACE_BEHAVIOURS.SAVE]: "saveToCurrent",
  [SAVE_WORKSPACE_BEHAVIOURS.CREATE_NEW]: "createNew",
  [SAVE_WORKSPACE_BEHAVIOURS.DO_NOT_SAVE]: "doNotSave",
};
